<template>
  <button class="order-item__status_button" v-if="canAddPhoto">+ {{$t('forms.photo')}}</button>
  <span
    v-else-if="!isAction"
  >{{$t(`${list == false ? 'orderDetailsStatuses': 'ordersStatuses'}.${status}`)}}</span>

  <button
    class="order-item__status_button"
    v-else
  >{{$t(`${list == false ? 'orderDetailsStatuses': 'ordersStatuses'}.${status}`)}}</button>
</template>

<script>
export default {
  name: "orders-list-btn",
  props: {
    status: {
      required: true
    },
    list: {
      required: false,
      default: true
    }
  },
  computed: {
    isAction() {
      return (
        this.status == "job_finished" ||
        this.status == "payment" ||
        this.status == "rating_review"
      );
    },
    canAddPhoto() {
      return (
        this.status == "new" ||
        this.status == "stand_by" ||
        this.status == "confirmed"
      );
    }
  }
};
</script>